import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Variation} from '@emm/common-items/models/variation.model';
import {Item} from '@emm/common-items/models/item.model';

@Component({
    selector: 'emm-overrides-card',
    templateUrl: './overrides-card.component.html',
    styleUrls: ['./overrides-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverridesCardComponent {
    @Input() variation: Variation | null = null;
    @Input() overridesLength: number | null = null;
    @Input() hasComponentOverrides: boolean | null = null;
    @Input() item: Item | any | null = null;

    get isBaseItem(): boolean {
        return this.variation?.variationLabel === 'Base Item';
    }

    get variationHeader(): string {
        const v = this.variation;
        if (!v) {
            return '';
        }
        return v.variationLabel ? `${v.variationTag} - ${v.variationLabel}` : v.variationTag;
    }
}
